import { BaseCachePayload } from 'src/app/cache/base-cache.payload';

export class ProjectCachePayload extends BaseCachePayload {}
